import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table table-tenant" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }

import { ref, onMounted } from "vue";
import AccountService from "../services/AccountService";
import {
  ServiceToPlatform,
  demoPlatformSelections,
} from "@/core/types/ServiceTypes";
import BalanceShow from "@/components/BalanceShow.vue";
import { ElNotification, ElMessageBox } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  __name: 'DemoAccounts',
  setup(__props) {

const isLoading = ref(false);
const data = ref(<any>[]);
const currentTime = new Date().toISOString();
const criteria = ref<any>({
  page: 1,
  pageSize: 20,
});
const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const res = await AccountService.queryDemoAccounts(criteria.value);
    criteria.value = res.criteria;
    data.value = res.data;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

const reset = () => {
  criteria.value = {
    page: 1,
    pageSize: 20,
  };
  fetchData(1);
};

const deleteDemoAccount = async (item: any) => {
  try {
    ElMessageBox.confirm(
      "Are you sure to delete this account?",
      " Account Number: " + item.accountNumber,
      {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }
    ).then(async () => {
      await AccountService.deleteDemoAccount(item.id);
      fetchData(1);
      ElNotification({
        title: "Success",
        message: "Account deleted successfully",
        type: "success",
      });
    });
  } catch (error) {
    console.log(error);
  }
};

onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          modelValue: criteria.value.accountNumber,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.accountNumber) = $event)),
          placeholder: _ctx.$t('fields.accountNo'),
          clearable: "",
          disabled: isLoading.value,
          class: "me-3"
        }, null, 8, ["modelValue", "placeholder", "disabled"]),
        _createVNode(_component_el_select, {
          modelValue: criteria.value.serviceId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.serviceId) = $event)),
          class: "me-3",
          clearable: "",
          placeholder: _ctx.$t('fields.mtPlatform')
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(demoPlatformSelections), (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.platform,
                label: item.label,
                value: item.platform
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_el_button, {
          type: "success",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (fetchData(1))),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (reset())),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.user")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.accountNo")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.accountType")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.platform")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.currency")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.balance")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.leverage")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.expireDate")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.action")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && data.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_UserInfo, {
                        email: item.email,
                        name: item.name ? item.name : 'N/A',
                        partyId: item.partyId,
                        class: "me-2"
                      }, null, 8, ["email", "name", "partyId"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.accountNumber), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t("type.account." + item.type)), 1),
                    _createElementVNode("td", null, _toDisplayString(_unref(ServiceToPlatform)[item.serviceId]), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t("type.currency." + item.currencyId)), 1),
                    _createElementVNode("td", null, [
                      _createVNode(BalanceShow, {
                        balance: item.balance * 100,
                        currencyId: item.currencyId
                      }, null, 8, ["balance", "currencyId"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.leverage) + ":1", 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        "date-iso-string": item.expireOn,
                        class: _normalizeClass([
                  item.expireOn < _unref(currentTime) ? 'text-danger' : 'text-success',
                ])
                      }, null, 8, ["date-iso-string", "class"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        "date-iso-string": item.createdOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_button, {
                        type: "danger",
                        size: "small",
                        onClick: ($event: any) => (deleteDemoAccount(item)),
                        disabled: isLoading.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("action.delete")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"])
                    ])
                  ]))
                }), 128))
              ]))
      ]),
      _createVNode(_component_TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ])
  ]))
}
}

})